import React from 'react';
import {
Dialog,
DialogTitle,
DialogContent,
DialogActions,
Stack,
Typography,
IconButton,
Button,
} from '@mui/material';
import { PictureAsPdf, Close, Download } from '@mui/icons-material';

const PdfPreviewDialog = ({ open, onClose, pdfPreviewUrl, onDownload }) => (
<Dialog
open={open}
onClose={onClose}
maxWidth="lg"
fullWidth
slotProps={{ paper: {
sx: {
borderRadius: 4,
height: '92vh',
maxHeight: '92vh',
background: '#f8fafc',
overflow: 'hidden',
},
} }}
>
<DialogTitle
sx={{
background: 'linear-gradient(120deg,#0f2942,#117aa7)',
color: '#fff',
display: 'flex',
alignItems: 'center',
justifyContent: 'space-between',
py: 2,
px: 3,
}}
>
<Stack direction="row" spacing={1.5} alignItems="center">
<PictureAsPdf sx={{ fontSize: 22 }} />
<Typography sx={{ fontWeight: 700, fontSize: '1rem' }}>
Apercu Analyse de Compatibilite
</Typography>
</Stack>
<IconButton
onClick={onClose}
sx={{ color: 'rgba(255,255,255,.8)', '&:hover': { color: '#fff', bgcolor: 'rgba(255,255,255,.12)' } }}
>
<Close />
</IconButton>
</DialogTitle>

<DialogContent sx={{ p: 0, flex: 1, overflow: 'hidden' }}>
{pdfPreviewUrl && (
<iframe
src={pdfPreviewUrl}
title="Previsualisation PDF"
width="100%"
height="100%"
style={{ border: 'none', display: 'block' }}
/>
)}
</DialogContent>

<DialogActions
sx={{
px: 3,
py: 2,
borderTop: '1px solid rgba(0,0,0,.07)',
background: '#fff',
gap: 1.5,
}}
>
<Button
onClick={onClose}
variant="outlined"
startIcon={<Close />}
sx={{ textTransform: 'none', borderRadius: 8, color: '#64748b', borderColor: '#cbd5e1' }}
>
Fermer
</Button>
<Button
onClick={onDownload}
variant="contained"
startIcon={<Download />}
sx={{
textTransform: 'none',
borderRadius: 8,
bgcolor: '#117aa7',
'&:hover': { bgcolor: '#0d5a7a' },
fontWeight: 600,
px: 3,
}}
>
Telecharger le PDF
</Button>
</DialogActions>
</Dialog>
);

export default PdfPreviewDialog;
